/**
 * frontend/src/lib/constants.js — rules the UI shares with the backend. One definition each,
 * so pages cannot drift apart.
 */

/** A built playlist can be shared once it is public and has at least this many tracks.
 *  Must match SHARE_MIN_TRACKS in backend/routes/builtPlaylists.js (Sprint 6A.1: 5 → 4). */
export const PLAYLIST_SHARE_MIN_TRACKS = 4;

/** Public origin for every link a user copies or shares (referrals, share text). Always the
 *  canonical domain, never window.location.origin: a visitor on a legacy host
 *  (sounddao-game.vercel.app) must not keep spreading it. */
export const PUBLIC_APP_URL = (process.env.REACT_APP_PUBLIC_URL || 'https://app.sounddao.com').replace(/\/+$/, '');

/** https://app.sounddao.com/invite/<code>, or the bare app URL without a code. */
export const inviteUrl = (referralCode) =>
  (referralCode ? `${PUBLIC_APP_URL}/invite/${encodeURIComponent(referralCode)}` : PUBLIC_APP_URL);
